module.exports = __webpack_public_path__ + "99feaa1697590743613a3222d971facc.svg";